export default [
	'background-position-x',
	'background-position-y',
	'background-size',
	'border-image-outset',
	'border-top-width',
	'border-right-width',
	'border-bottom-width',
	'border-left-width',
	'border-top-left-radius',
	'border-top-right-radius',
	'border-bottom-right-radius',
	'border-bottom-left-radius',
	'border-image-width',
	'clip',
	'font-size',
	'padding-top',
	'padding-right',
	'padding-bottom',
	'padding-left',
	'margin-top',
	'margin-right',
	'margin-bottom',
	'margin-left',
	'width',
	'height',
	'min-width',
	'min-height',
	'max-width',
	'max-height',
	'top',
	'right',
	'bottom',
	'left',
	'outline-width',
	'outline-offset',
	'letter-spacing',
	'word-spacing',
	'text-indent',
	'line-height'
];
